// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__kXUqp","leftWrapper":"styles_leftWrapper__kuU+m","rightWrapper":"styles_rightWrapper__14Ou7"};